import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { isTrialUser } from "@/constants/trialVersion";
import { getAuthItem } from "@/utils/authStorage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../Layouts/AuthLayout.vue"),
    redirect: "/login",
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("../views/auth/login.vue"),
      },
    ],
  },
  {
    path: "/forgotPassword",
    name: "ForgotPassword",
    component: () => import("../views/auth/ForgotPassword.vue"),
  },
  {
    path: "/privacypolicyagreement",
    name: "privacypolicyagreement",
    component: () => import("../views/PrivacyPolicy/privacyPolicyGernel.vue"),
  },
  {
    path: "/termsandconditions",
    name: "termsandconditions",
    component: () => import("../views/Terms/index.vue"),
  },
  {
    path: "/agreement",
    name: "agreement",
    component: () => import("../components/AgreementPage/index.vue"),
  },
  {
    path: "/resetPassword/:id",
    name: "resetPassword",
    component: () => import("../views/auth/ResetPassword.vue"),
  },
  {
    path: "/overview",
    component: () => import("../Layouts/AdminLayout.vue"),
    redirect: "/overview",
    children: [
      {
        path: "/overview",
        name: "overview",
        component: () => import("../views/Overview/index.vue"),
      },
      {
        path: "/template",
        component: () => import("../views/Template/index.vue"),
      },
      {
        path: "/assigntemplate",
        component: () => import("../views/AssignTemplate/index.vue"),
      },
      {
        path: "/alltickets",
        component: () => import("../views/AllTickets/index.vue"),
      },
      {
        path: "/allassigntemplate",
        component: () => import("../views/AllAssignTemplate/index.vue"),
      },
      {
        path: "/template/addtemplate",
        component: () => import("../views/Template/addTemplate.vue"),
      },
      {
        path: "/assigntemplate/templatetask",
        component: () => import("../views/AssignTemplate/templateTask.vue"),
      },
      {
        path: "/templatetask",
        component: () => import("../views/TemplateTasks/index.vue"),
      },
      {
        path: "/tickets",
        component: () => import("../views/Tickets/index.vue"),
      },
      {
        path: "/temptasks",
        component: () => import("../views/TempQuestion/index.vue"),
      },
      // {
      //   path: "/temptask/addtemptask",
      //   component: () => import("../views/TempQuestion/addTempQuestion.vue"),
      // },
      {
        path: "/department",
        component: () => import("../views/Department/index.vue"),
      },
      {
        path: "/admin-users",
        component: () => import("../views/AdminUsers/index.vue"),
        meta: { requiresMainOrgAdmin: true, blockOnTrial: true },
      },
      {
        path: "/privacypolicy",
        name: "privacypolicy",
        component: () => import("../views/PrivacyPolicy/index.vue"),
      },
      {
        path: "/aboutus",
        component: () => import("../views/AboutUs/index.vue"),
      },
      {
        path: "/organizationmap",
        component: () => import("../views/OrganizationMap/index.vue"),
      },
      // {
      //   path: "/department/adddepartment",
      //   component: () => import("../components/Department/addDepartment.vue"),
      // },
      {
        path: "/employees",
        component: () => import("../views/Employee/index.vue"),
      },
      // {
      //   path: "/employees/addemployee",
      //   component: () => import("../components/Employee/addEmployee.vue"),
      // },
      {
        path: "/rooms",
        component: () => import("../views/Rooms/index.vue"),
      },
      {
        path: "/rooms/addrooms/:id",
        component: () => import("../components/Room/addRooms.vue"),
      },
      {
        path: "/report",
        // component: () => import("../views/Report/index.vue"),
        component: () => import("../views/Report2/index.vue"),
      },
      {
        path: "/report2",
        component: () => import("../views/Report2/index.vue"),
      },
      {
        path: "/setting",
        component: () => import("../views/Setting/index.vue"),
      },
      {
        path: "/profile",
        component: () => import("../views/Profile/index.vue"),
      },
      {
        path: "/maintenance",
        component: () => import("../views/Maintenance/index.vue"),
      },
      {
        path: "/maintenance/history/:id",
        component: () => import("../views/Maintenance/history.vue"),
      },
      {
        path: "/pasttemplate",
        component: () => import("../views/PastTemplate/index.vue"),
      },
      {
        path: "/videos",
        name: "videos",
        component: () => import("../views/Videos/index.vue"),
      },
      // {
      //   path: "/subscription",
      //   component: () => import("../views/Subscription/index.vue"),
      // },
      // {
      //   path: "/subscription/plans",
      //   component: () => import("../views/Subscription/plans.vue"),
      // },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name === "login" && getAuthItem("roomround_access_token")) {
    setTimeout(() => {
      next();
    }, 500);
  } else {
    const roomround_access_token = getAuthItem(
      "roomround_access_token"
    );
    if (roomround_access_token) {
      // Restrict routes that require main organization admin
      if (to.matched.some((record) => record.meta && record.meta.requiresMainOrgAdmin)) {
        const adminData = store.getters && store.getters.getAdminData;
        const isMain = !!(adminData && adminData.data && adminData.data.isMainOrganizationAdmin);
        if (!isMain) {
          return next({ path: "/overview" });
        }
      }
      if (to.matched.some((record) => record.meta && record.meta.blockOnTrial)) {
        const adminData = store.getters && store.getters.getAdminData;
        if (isTrialUser(adminData)) {
          return next({ path: "/overview" });
        }
      }
      if (to.name === "login") {
        next({ name: "overview" });
      } else {
        next();
      }
    } else if (to.name === "login") {
      next();
    } else {
      // If the user is not logged in
      if (
        [
          "login",
          "ForgotPassword",
          "resetPassword",
          "privacypolicyagreement",
          "termsandconditions",
          "agreement",
        ].includes(to.name)
      ) {
        next();
      } else {
        next({ name: "login" });
      }
    }
  }
});
// router.beforeEach((to, from, next) => {
//   const roomround_access_token = localStorage.getItem("roomround_access_token");

//   if (to.name === "login" && roomround_access_token) {
//     // Add a delay before navigating if already logged in and trying to access login page
//     setTimeout(() => {
//       next({ name: "overview" });
//     }, 3000);

//   } else if (roomround_access_token) {
//     // If the user is logged in
//     if (to.name === "login") {
//       next({ name: "overview" });
//     } else {
//       next();
//     }
//   } else {
//     // If the user is not logged in
//     if (["login", "ForgotPassword", "resetPassword"].includes(to.name)) {
//       next();
//     } else {
//       next({ name: "login" });
//     }
//   }
// });

export default router;
